import Singleton from '../util/Singleton';
import { VirtualCounter } from './VirtualCounter';

class VirtualCounterManager extends Singleton<VirtualCounterManager>() {
    private _counters: Map<string, VirtualCounter> = new Map();

    /**
     * Fetches the requested endpoint or creates a new one
     */
    public getCounter(endpoint: string): VirtualCounter {
        if (this._counters.has(endpoint)) {
            return this._counters.get(endpoint)!;
        } else {
            const vcm = new VirtualCounter(endpoint);
            this._counters.set(endpoint, vcm);
            return vcm;
        }
    }
}

export default VirtualCounterManager.getInstance();
